import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { projectsData, projectsNav } from "./Data";
import WorkItems from "./WorkItems";
import { motion } from "framer-motion";

const Works = () => {
  const [item, setItem] = useState({ name: "all" });
  const [projects, setProjects] = useState([]);
  const [active, setActive] = useState(0);
  const [visible, setVisible] = useState(3);

  const showMoreItems = () => {
    setVisible((prev) => Math.min(prev + 3, projects.length));
  };
  const showLessItems = () => {
    setVisible((prev) => Math.max(prev - 3, 3));
  };

  useEffect(() => {
    if (item.name === "all") {
      setProjects(projectsData);
    } else {
      const newProjects = projectsData.filter((project) => {
        return project.category.toLowerCase() === item.name;
      });
      setProjects(newProjects);
    }
  }, [item]);

  const handleClick = (e, index) => {
    setItem({ name: e.target.textContent.toLowerCase() });
    setActive(index);
  };
  return (
    <div>
      <div className="work__filters">
        {projectsNav.map((item, index) => {
          return (
            <span
              onClick={(e) => {
                handleClick(e, index);
              }}
              className={`${active === index ? "active-work" : ""} work__item`}
              key={index}
            >
              {item.name}
            </span>
          );
        })}
      </div>

      <motion.div layout className="work__container container grid">
        {projects.slice(0, visible).map((item) => {
          return <WorkItems item={item} key={item.id} />;
        })}
      </motion.div>

      <div className="items__button">
        <motion.button
          transition={{ duration: 0.1 }}
          whileHover={{
            scale: 1.05,
          }}
          onClick={showMoreItems}
          className={`${
            projects.length === visible ? "hide__button" : "button button--flex"
          }`}
        >
          Load More
        </motion.button>

        <motion.button
          transition={{ duration: 0.1 }}
          whileHover={{
            scale: 1.05,
          }}
          onClick={showLessItems}
          className={`${visible > 3 ? "button button--flex" : "hide__button"}`}
        >
          Load Less
        </motion.button>
      </div>
    </div>
  );
};

export default Works;
